/* BTR 2026-09-26: "See it in action" product video player (section btr-product-videos).
   Cards hold their <video> markup in a <template>, so nothing loads until a card is tapped.
   Also handles the "Watch videos" jump links rendered by snippets/btr-video-jump.liquid. */
(function () {
  function init() {
    var root = document.querySelector('[data-pv-root]');
    if (!root) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pv-card]'));
    var dlg = root.querySelector('.btr-pv-player');
    if (!cards.length || !dlg) return;

    var stage = dlg.querySelector('.btr-pv-player__stage');
    var badge = dlg.querySelector('.btr-pv-player__badge');
    var title = dlg.querySelector('.btr-pv-player__title');
    var meta = dlg.querySelector('.btr-pv-player__meta');
    var text = dlg.querySelector('.btr-pv-player__text');
    var inc = dlg.querySelector('.btr-pv-player__inc');
    var dots = dlg.querySelector('.btr-pv-player__dots');
    var priceEl = dlg.querySelector('[data-pv-price]');
    var addBtn = dlg.querySelector('[data-pv-add]');
    var current = -1;
    var opener = null;

    function track(name, params) {
      try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
    }

    function mainAddButton() {
      return document.querySelector('.product__info-container product-form button[name="add"], .product__info-container button[name="add"]');
    }

    function syncBuyBar() {
      var p = document.querySelector('.product__info-container .price');
      if (p && priceEl) {
        var el = p.classList.contains('price--on-sale')
          ? p.querySelector('.price__sale .price-item--sale')
          : p.querySelector('.price__regular .price-item--regular');
        if (el && el.textContent.trim()) priceEl.textContent = el.textContent.trim();
      }
      var main = mainAddButton();
      if (addBtn) {
        var soldOut = !main || main.disabled;
        addBtn.disabled = soldOut;
        addBtn.textContent = soldOut ? 'Sold out' : 'Add to Basket';
      }
    }

    function stopVideo() {
      var v = stage.querySelector('video');
      if (v) { try { v.pause(); } catch (e) {} }
      stage.innerHTML = '';
    }

    function show(n) {
      n = (n + cards.length) % cards.length;
      stopVideo();
      current = n;
      var card = cards[n];
      var d = card.dataset;
      var tpl = card.parentElement.querySelector('template[data-pv-src]');
      var isCust = d.pvKind === 'customer';
      var ratio = parseFloat(d.pvRatio) || 1;

      dlg.classList.toggle('btr-pv-player--customer', isCust);
      dlg.classList.toggle('btr-pv-player--wide', ratio > 1.2);
      stage.style.setProperty('--pv-ratio', String(ratio));

      badge.textContent = isCust ? 'Customer video' : 'BTR video';
      title.textContent = isCust && d.pvName ? d.pvName : d.pvTitle;
      if (isCust) {
        var bits = [];
        if (d.pvName) bits.push(d.pvTitle);
        if (d.pvVerified === 'true') bits.push('✓ Verified buyer');
        meta.textContent = bits.join(' · ');
        text.textContent = d.pvQuote ? '“' + d.pvQuote + '”' : '';
        inc.textContent = d.pvIncentive || '';
      } else {
        meta.textContent = '';
        text.textContent = d.pvDescription || '';
        inc.textContent = '';
      }

      dots.innerHTML = '';
      for (var i = 0; i < cards.length; i++) {
        var dot = document.createElement('i');
        if (i === n) dot.className = 'is-on';
        dots.appendChild(dot);
      }

      if (tpl) {
        stage.appendChild(tpl.content.cloneNode(true));
        var v = stage.querySelector('video');
        if (v) {
          v.setAttribute('playsinline', '');
          v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) {
            p.catch(function () { v.muted = true; v.play().catch(function () {}); });
          }
        }
      }
      track('btr_video_play', { video_title: d.pvTitle, made_by: isCust ? 'customer' : 'btr', position: n + 1 });
    }

    function open(n, from) {
      opener = from || document.activeElement;
      syncBuyBar();
      dlg.classList.toggle('btr-pv-player--single', cards.length < 2);
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('btr-pv-lock');
      show(n);
    }

    function close() {
      stopVideo();
      if (dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
    }

    dlg.addEventListener('close', function () {
      stopVideo();
      document.documentElement.classList.remove('btr-pv-lock');
      if (opener && opener.focus) opener.focus();
    });

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () { open(i, card); });
    });

    dlg.querySelector('.btr-pv-player__close').addEventListener('click', close);
    dlg.querySelector('.btr-pv-player__nav--prev').addEventListener('click', function () { show(current - 1); });
    dlg.querySelector('.btr-pv-player__nav--next').addEventListener('click', function () { show(current + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('keydown', function (e) {
      if (cards.length < 2) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
    });

    // Swipe left or right anywhere on the player (ignores mostly vertical moves).
    var sx = null, sy = null;
    dlg.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (sx === null || cards.length < 2) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      sx = sy = null;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) show(current + (dx < 0 ? 1 : -1));
    }, { passive: true });

    // Add to Basket uses the main product form, so the chosen variant, quantity and cart drawer all behave as normal.
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var main = mainAddButton();
        var d = cards[current] ? cards[current].dataset : {};
        track('btr_video_add_to_cart', { video_title: d.pvTitle, made_by: d.pvKind });
        close();
        if (main && !main.disabled) main.click();
      });
    }

    var invite = root.querySelector('[data-btr-video-invite]');
    if (invite) {
      invite.addEventListener('click', function () { track('btr_video_invite', { link: invite.getAttribute('href') }); });
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-btr-video-jump]'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        track('btr_video_jump', { from: a.getAttribute('data-btr-video-jump') });
        var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        root.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
